import { useEffect } from 'react';
import { socket } from './socket';

export const useSocketHook = (isSocketConnected, socketListeners) => {

        if (!isSocketConnected) {
            return;
        }
    
        socketListeners.forEach(({ socketlistener, callback }) => {
            socket.on(socketlistener, callback);
        });
    
 
};
